///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'kb-button',
    templateUrl: './button.component.html',
})
export class KbButtonComponent {
    @ViewChild('button')
    public button: ElementRef;

    @Input()
    public config: any;
}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/shared/components/button/button.component.ts